import React from 'react'
import { Link } from 'react-router-dom'

import _ from 'lodash'

import { variantsDecl } from 'app/utils'
import { priceFormat } from 'app/utils'

import { BrowserView, MobileView, isBrowser, isMobile } from "react-device-detect";

class OptionSelectBox extends React.Component {
  constructor(props) {
    super(props);
    this.zeroCountMessage = this.props.zeroCountMessage || 'Нет загруженных вариантов.';
    this.state = {
      showPopup: false,
      selected: null,
      filter: null
    }
  }

  openModal(e) {
    e.preventDefault();
    this.hideHint();
    this.setState({showPopup : true});
  };

  closeModal(e) {
    e.preventDefault();
    this.props.removeFromActionsChain && this.props.removeFromActionsChain(this.props.group);
    this.hideHint();
    this.setState({
      showPopup: false
    });
  };

  onSelectItem(item, event) {
    event.preventDefault();
    this.setState({selected : item}, () => {
      if (this.state.selected) {
        this.props.onItemSelected(this.state.selected, this.props.group);
        this.hideHint();
        this.setState({
          showPopup: false
        });
      }
    });
  }

  onSelectItemImmediately(item, event) {
    event.preventDefault();
    event.stopPropagation();
    this.hideHint();
    this.props.onItemSelected(item, this.props.group);
  }

  removeItem(item, event) {
    event.preventDefault();
    this.props.onItemSelected(item, this.props.group);
    this.setState({selected : null});
  }

  confirmSelected(event) {
    event.preventDefault();

    if (this.state.selected) {
      this.props.onItemSelected(this.state.selected, this.props.group);
      this.hideHint();
      this.setState({
        showPopup: false
      });
    }
  }

  showHint(hint, event) {
    if (!hint) {
      return false;
    }
    let target = event.target;

    if (target.stateNode != 'LI') {
      target = target.closest('li');
    }

    let
      rect = target.getBoundingClientRect(),
      x = rect.left + rect.width,
      y = rect.top;

    this.props.showHint({text: hint, x: x, y: y});
  }

  hideHint() {
    this.props.hideHint();
  }

  renderSelectOptions() {
    let items = this.props.collection;
    if (this.state.filter) {
      items = _.filter(items, {custom_part_type_id: this.state.filter});
    }
    return items.map((item, index) => {
      let isSelected = _.get(this.state.selected, 'id') == item.id;

      return (
        <li key={index} className={`options-select-list-item selectable-block selectable-block-clean ${isSelected ? 'selected' : ''}`}
            onMouseMove={ this.showHint.bind(this, item.hint) }
            onMouseLeave={ this.hideHint.bind(this, item.hint) }
            onClick={this.onSelectItem.bind(this, item)}>

          <div className='selectable-block-indicator'></div>
          <div className='options-select-image'>
            <img src={ _.get(item, 'preview.url') } />
          </div>
          <div className='options-select-title'>{item.title}</div>
        </li>
      );
    });
  }

  optionsForTowOptions() {
    return this.props.collection.map((item, index) => {
      let isSelected = _.get(this.props.currentGroupItem, 'id') == item.id;

      return (
        <div key={index} className={`col-${index + 1}-`}>
          <div className='selected-option-block'
               onClick={this.onSelectItemImmediately.bind(this, item)}
          >
            <div className='selected-option-block-image'>
              <img src={ _.get(item, 'preview.url') } />
            </div>
            <div className='selected-option-block-info'>
              <div className='selected-option-block-title'>
                {item.title}
              </div>
              <div className='selected-option-block-price'>{priceFormat(item.price)}</div>
              {(()=> isSelected ? (<a className='remove' onClick={this.onSelectItemImmediately.bind(this, this.props.currentGroupItem)} href='#'>Убрать</a>) : '')()}
            </div>
          </div>
        </div>
      );
    });
  }

  renderTwoSelectOptions() {
    return (
     <div className="form option-select-form two-cols- two-options-for-select">
       {this.optionsForTowOptions()}
     </div>
    )
  }

  setFilter(filter, event) {
    event.preventDefault();
    this.setState({
      filter: filter
    });
  }

  renderFilters() {
    let items = this.props.collection;

    if (!this.props.typeFilter) {
      return '';
    }
    let filters = this.props.typeFilter.map((item, index) => {
      let itemsForFilterExist = !!_.filter(items, {custom_part_type_id: item.id}).length;

      return itemsForFilterExist ? (
        <li key={ index } className={`popup-submenu-item ${this.state.filter == item.id ? 'active' : ''}`}>
          <a href='#' onClick={this.setFilter.bind(this, item.id)} >{item.title}</a>
        </li>
      ) : null;
    });
    return (
      <ul className='popup-submenu'>
        <li className={`popup-submenu-item ${this.state.filter ? '' : 'active'}`}>
          <a href='#' onClick={this.setFilter.bind(this, null)}>Все</a>
        </li>
        { filters }
      </ul>
    );
  }

  selectedContent() {
    return (
      <div className='form option-select-form two-cols- option-selected-'>
        <div className='col-1-'>
          <div className='selected-option-block'>
            <div className='selected-option-block-image'>
              <img src={_.get(this.props.currentGroupItem, 'preview.url')}/>
            </div>
            <div className='selected-option-block-info'>
              <div className='selected-option-block-title'>{this.props.currentGroupItem.title}</div>
              <div className='selected-option-block-price'>{priceFormat(this.props.currentGroupItem.price)}</div>
              <a className='remove' onClick={this.removeItem.bind(this, this.props.currentGroupItem)} href='#'>Убрать</a>
            </div>
          </div>
        </div>
        <div className='col-2-'>
          <div className='button button-small button-grey' onClick={this.openModal.bind(this)} >
            <span>
              { this.props.buttonShortTitle }
            </span>
          </div>
          <div className='counter-'>
            { !!this.props.collection.length ? `${this.props.collection.length} ${variantsDecl(this.props.collection.length)}` : this.zeroCountMessage }
          </div>
        </div>
      </div>
    )
  }

  componentWillUpdate(newProps, oldProps) {
    if (newProps.showNow && !this.state.showPopup) {
      this.setState({showPopup: true});
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.showNow && !this.state.showPopup) {
      this.setState({showPopup: true});
    }
  }

  selectedContentMobile() {
    return (
      <div className='form option-select-form two-cols- option-selected-'>
        <div className='col-1-'>
          <div className='selected-option-block'>
            <div className='selected-option-block-image'>
              <img src={_.get(this.props.currentGroupItem, 'preview.url')}/>
            </div>
            <a className='remove' onClick={this.removeItem.bind(this, this.props.currentGroupItem)} href='#'>Убрать</a>
          </div>
        </div>
        <div className='col-2-'>
          <div className='selected-option-block-info'>
            <div className='selected-option-block-title'>
              {this.props.currentGroupItem.title}
              &nbsp;
              {priceFormat(this.props.currentGroupItem.price)}
            </div>
          </div>
          <div className='button button-small button-grey' onClick={this.openModal.bind(this)} >
            <span>
              { this.props.buttonShortTitle }
            </span>
          </div>
        </div>
      </div>
    )
  }

  renderSelectPopup() {
    return (
      <div className={`popup-layer ${this.state.showPopup ? 'active' : ''}`} >
        <div className='popup-wrapper'>
          <div className='base-width'>
            <div className='popup'>
              <div className='popup-header'>
                <a className='close ' onClick={this.closeModal.bind(this)} href='#'>Закрыть окно</a>
                <h2>
                  { this.props.title }
                </h2>
                { this.renderFilters() }
              </div>
              { !this.props.collection.length ? this.popupEmptyContent() : this.popupItemsContent() }
            </div>
          </div>
          <div className='cover-all' onClick={this.closeModal.bind(this)}></div>
        </div>
      </div>
    );
  }

  popupItemsContent() {
    return this.state.showPopup ? (
      <React.Fragment>
        <div className='popup-body'>
          <ul className={`options-select-list ${this.props.optionsListClass}`}>
            { this.renderSelectOptions() }
          </ul>
        </div>
        <div className='popup-footer'>
          <a className={`button button-red button-large ${this.state.selected ? 'disabled' : ''}`}
             onClick={this.confirmSelected.bind(this)} href='#'>
                  <span>
                    {`${this.props.buttonTitle} ${this.state.selected ? this.state.selected.title : ''}`}
                  </span>
          </a>
          <a className='close' onClick={this.closeModal.bind(this)} href='#'>Закрыть окно</a>
        </div>
      </React.Fragment>
    ) : null;
  }

  popupEmptyContent() {
    return (
      <React.Fragment>
        <div className='popup-body'>
          {this.zeroCountMessage}
        </div>
        <div className='popup-footer'>
          <a className='close' onClick={this.closeModal.bind(this)} href='#'>Закрыть окно</a>
        </div>
      </React.Fragment>
    );
  }

  unSelectedContent() {
    return (
      <div className='form option-select-form two-cols-'>
        <div className='col-1-'></div>
        <div className='col-2- mobile-hidden'>
          <a className='button button-large button-grey' onClick={this.openModal.bind(this)} href='#'>
              <span>
                { this.props.buttonTitle }
              </span>
            <div className='counter-'>
              { !!this.props.collection.length ? `${this.props.collection.length} ${variantsDecl(this.props.collection.length)}` : this.zeroCountMessage }
            </div>
          </a>
        </div>
      </div>
    );
  }

  renderBox() {
    return (!!this.props.currentGroupItem ? (isMobile ? this.selectedContentMobile.bind(this) : this.selectedContent.bind(this)) : this.unSelectedContent.bind(this));
  }

  render() {
    let mainClass = this.props.withoutSelectable ? '' : `wizard-block-form selectable-block ${!!this.props.currentGroupItem ? 'selected' : ''}`;
    return (
      <div>
        <div className={ mainClass }>
          <div className='selectable-block-indicator'></div>
          <div className='selectable-block-title'>
            {this.props.title}
            { this.props.constructionOptions[this.props.group] && this.props.needRequire ? (<span className="required-option">обязательно</span>) : null }
            <div className='mobile-show'>
              <a className='hover-select-link' onClick={this.openModal.bind(this)} href='#'/>
            </div>
          </div>
          { this.renderBox()() }
        </div>
        { this.renderSelectPopup() }
      </div>
    );
  }
}

export default OptionSelectBox;



// WEBPACK FOOTER //
// ./app/javascript/app/components/option_select_box/index.jsx